import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Country, ICountryBO, IRegionBO } from '@mapfre-tech/amap3';
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";
import { AuthService, CacheService } from '@mapfre-tech/amap3';
import { Router } from '@angular/router';

@Injectable({
   providedIn: "root"
})
export class CountryService {

   className = 'CountryService'

   sections = [
      'administration',
      'works/dashboard',
      'recommendations/dashboard',
      'following'
   ]

   constructor(private http: HttpClient, private authService: AuthService, private router: Router, private cacheService: CacheService) { }

   getAllCountries(cache = true): Observable<ICountryBO[]> {
      const isAdminSection = this.sections.some(section => this.router.url.includes(section));
      const cacheKey = "allCountries" + "_" + isAdminSection.toString();
      if (this.cacheService.canUseCache(cacheKey) && cache) {
         return this.cacheService.getCacheData(cacheKey) as object as Observable<ICountryBO[]>;
      } else {
         const observable = this.http.get<Country[]>(environment.base_URL + "/countries").pipe(map((res) => {
            if (isAdminSection) {
               this.cacheService.updateCacheData(res, cacheKey);
               return res;
            } else {
               const filtrado = res.filter(it => it.mrkActive);
               this.cacheService.updateCacheData(filtrado, cacheKey);
               return filtrado;
            }
         }));
         this.cacheService.updateCacheReq(cacheKey);
         return observable as object as Observable<ICountryBO[]>;
      }
   }

   newCountry(country: ICountryBO) {
      return this.http.post(environment.base_URL + "/countries", country).pipe(tap(() => this.deleteCache()))
   }

   updateCountry(country: ICountryBO, id: number) {
      return this.http.put(environment.base_URL + `/countries/${id}`, country).pipe(tap(() => this.deleteCache()))
   }

   deleteCache() {
      this.cacheService.deleteCache('allCountries');
   }

   getAllRegions(): Observable<IRegionBO[]> {
      return this.getAllCountries().pipe(map((countries) => {
         const regions = countries.map(c => c.region).filter((r): r is IRegionBO => r != null);
         return regions.filter((v, i, a) => a.findIndex(r => r.txtRegion === v.txtRegion) === i);
      }));
   }

}
